module.exports = __webpack_public_path__ + "dj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/dj.svg
// module id = 518
// module chunks = 0